// extracted by mini-css-extract-plugin
export default {"root":"_1aktV","dd":"_2jCyD","hype":"_3UaTY"};